import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';
import './AuthPage.css';

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function isValidPhone(phone) {
  return /^\d{10}$/.test(phone.replace(/\D/g, ''));
}

function ForgotPassword() {
  const [identifier, setIdentifier] = useState('');
  const [status, setStatus] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validate = () => {
    if (!identifier.trim()) {
      setStatus({ type: 'error', text: '❌ Please enter your email or phone number' });
      return false;
    }
    if (!isValidEmail(identifier) && !isValidPhone(identifier)) {
      setStatus({ type: 'error', text: '❌ Please enter a valid email or 10-digit phone number' });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setStatus({ type: '', text: '' });

    try {
      await forgotPassword(identifier.trim());
      setSuccess(true);
    } catch (err) {
      setStatus({
        type: 'error',
        text: `❌ ${err.message || 'Failed to send reset link. Please try again.'}`,
      });
    } finally {
      setLoading(false);
    }
  };

  /* ── Success view (mirrors HTML successContainer exactly) ── */
  if (success) {
    return (
      <div className="auth-bg">
        <div className="auth-card">
          <div className="success-view">
            <div className="success-icon">✅</div>
            <h2>Check Your Email &amp; WhatsApp!</h2>
            <p>We've sent a password reset link to:</p>
            <p className="identifier-display">{identifier}</p>
            <p>Click the link to reset your password. The link will expire in 1 hour.</p>
            <div className="channels">
              <span>✉️ Email</span>
              <span>💬 WhatsApp</span>
            </div>
            {/* HTML has two buttons on the success screen */}
            <button
              className="back-btn"
              onClick={() => { setSuccess(false); setIdentifier(''); setStatus({ type: '', text: '' }); }}
            >
              Send to Different Email/Phone
            </button>
            {/* ← Added to match HTML "Back to Sign In" button */}
            <Link to="/signin" className="back-btn" style={{ display: 'block', textAlign: 'center', marginTop: '10px' }}>
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    );
  }

  /* ── Form view ── */
  return (
    <div className="auth-bg">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/512-app-icon.png" alt="Ab Meri Baari" className="auth-app-icon" />
          <div className="auth-logo">Ab Meri Baari</div>
          <h1 className="auth-title">Forgot Password?</h1>
          <p className="auth-subtitle">
            No worries! Enter your email or phone number and we'll send you a link to reset your password.
          </p>
        </div>

        <div className="info-box">
          💡 We'll send a password reset link via email and WhatsApp to help you regain access to your account.
        </div>

        {status.text && (
          <div className={`auth-message ${status.type}`}>{status.text}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="identifier">Email or Phone Number</label>
            <input
              type="text"
              id="identifier"
              placeholder="example@gmail.com or 9876543210"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
            />
            <p className="input-hint">📧 Email: user@example.com | 📱 Phone: 10-digit number (India)</p>
          </div>
          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? <><span className="spinner" />Sending reset link...</> : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Remember your password? <Link to="/signin">Sign In</Link></p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
